module.exports = __webpack_public_path__ + "static/media/inTouch.37eaa070.svg";